module.exports = __webpack_public_path__ + "static/media/CertificateBackground.c2dcd8a4.png";